import { useCallback, useState } from 'react';
import { Page } from './Page';
import { isoDate, parseLocal } from '../lib/dates';
import { RotaView } from '../components/staff/RotaView';
import { useDateIntent, useNav } from './NavContext';

// Rota section — the team's month, as its Fri–Thu weeks. The shown month is the
// app's shared anchor (top-bar date picker, month mode).
//
// There is no lens any more. The Wages tab was a whole second view of the same
// weeks; each week-block now ends in its own hours-&-wages strip, so the roster and
// the money are one page. That deleted this page's scroll-preserving lens switch
// along with it — a scroll-ratio capture-and-restore that existed ONLY because
// swapping lenses re-laid-out the entire month under your cursor. Expanding one
// week's strip changes one week, so the page no longer moves and there is nothing
// to preserve.
export function RotaPage() {
  const { anchor: anchorDate, setAnchor } = useNav();
  const anchor = isoDate(anchorDate);

  // Land on the week of a day another page handed us (On-duty "view all" from
  // Daily / Messages) — anchor in that day's month, and hand the view a one-shot
  // jump so its week scrolls into view even when the day is already shown.
  //
  // A one-shot (date | null), not a counter: MonthView mounts AFTER this fires (the
  // month's data is still loading when the nav lands), so a counter would be read as
  // its own baseline and the jump would be silently dropped. Null means "no jump" —
  // which is every plain open of the page, and why Rota opens at the top.
  const [jumpTo, setJumpTo] = useState<string | null>(null);
  useDateIntent('schedule', (date) => {
    setAnchor(parseLocal(date));
    setJumpTo(date);
  });
  const clearJump = useCallback(() => setJumpTo(null), []);

  return (
    <Page title="Rota">
      <RotaView anchor={anchor} jumpTo={jumpTo} onJumpDone={clearJump} />
    </Page>
  );
}
